import type {
  CertificateListServiceConfig,
  GetCertificateCSVConfig,
} from '@/services/httpServices/CertificateServices/types';

import { createQueryKey } from './queryKeyUtils';

export function certificateCsvLanguagesListKeys(params?: GetCertificateCSVConfig) {
  return createQueryKey(['certificateLanguages'], params);
}

export function certificateListKeys(params?: CertificateListServiceConfig) {
  return createQueryKey(['certificateList'], params);
}

/**
 * Creates a unique query key for infinite certificate list queries.
 * Includes 'infinite' prefix to differentiate from regular list queries.
 */
export function infiniteCertificateListKeys(params?: CertificateListServiceConfig) {
  return ['infinite', ...certificateListKeys(params)];
}
